import { Loader2 } from 'lucide-react';

/** Lightweight fallback for React.lazy boundaries.
 *
 * Kept intentionally minimal — a centered spinner with no shell chrome,
 * because the parent <AppLayout> already provides the sidebar + header.
 * Shows up only for the brief moment a route chunk is being fetched.
 */
export default function RouteLoader() {
  return (
    <div
      data-testid="route-loader"
      className="flex items-center justify-center min-h-[40vh] text-slate-400"
    >
      <Loader2 className="h-6 w-6 animate-spin" />
    </div>
  );
}
